import { Component, Input, SimpleChanges } from '@angular/core';
import { CourseService } from '../../Services/course.service';
import { min } from 'lodash';

// import * as L from 'leaflet';
// import 'leaflet-gpx';

// import '@raruto/leaflet-elevation/dist/leaflet-elevation.js';

@Component({
  selector: 'app-preview-track',
  template: require('./preview-track.component.html'),
  styles: [require('./preview-track.component.css')]
})
export class PreviewTrackComponent{
  @Input('courseID') id: number=-1;
  @Input('mapHeight') mapHeight: number=600;
  // id:number = -1;
  private map:any={};
  controlElevation:any={};
  gpxAvailable:boolean = false;
  scriptnode: HTMLScriptElement | undefined;

  // Watch for changes on @Input
  ngOnChanges(changes: SimpleChanges) {
    if (changes['id']) {
      setTimeout(() => { 
        this.showMap()
      },500);
    }  
  }

  constructor(private courseService: CourseService) {
    this.loadScripts();
   }

  loadScripts() {
    // https://stackoverflow.com/questions/34489916/how-to-load-external-scripts-dynamically-in-angular
    const dynamicScripts = [
     '/assets/js/previewTrack/previewTrack.js',
     '/assets/js/previewTrack/leaflet-src.js',
     '/assets/js/previewTrack/d3.min.js',
     '/assets/js/previewTrack/gpx.js',
     '/assets/js/previewTrack/leaflet-elevation.js',
     '/assets/js/previewTrack/script.js',
    ];
    for (let i = 0; i < dynamicScripts.length; i++) {
      const node = document.createElement('script');
      node.src = dynamicScripts[i];
      node.type = 'text/javascript';
      node.async = false;
      node.charset = 'utf-8';
      document.getElementsByTagName('head')[0].appendChild(node);
    }

  }

  showMap(){
    if (this.id > -1){
      this.courseService.getCourse(this.id).subscribe( async (res:any)=>{
        var url = '/uploads/tracks/' + res.fileName;

        try {
          const response = await fetch(url);
          // console.log(response);
          if (response.status != 404){
            this.gpxAvailable = true;
            (window as any).initmap(url);  
          } else{
            this.gpxAvailable = false;
            // (window as any).clearmap();  
          }
          // else{
          //    var el = document.getElementById('map-frame')
          //    if (el != null){
          //      el.innerHTML( <HTMLElement>("no track found"))
          //     }
          //     console.log(el)
          // }
        } 
        catch (error ) {
          // TypeError: Failed to fetch
          console.log('There was an error', error);
          
        } 

        
      })
    }
  }
  
  // (this.scriptnode as any).loadedContent();
  // var data = "/assets/downloads/Rit_001_boortmeerbeek.gpx";
  // (window as any).initmap(data);
  // loadedContent();
  // private initMap(): void {
  //   this.map = L.map('map', {
  //     center: [ 39.8282, -98.5795 ],
  //     zoom: 3
  //   });

  //   const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
  //     maxZoom: 18,
  //     minZoom: 3,
  //     attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
  //   });

  //   tiles.addTo(this.map);
  // }

  // private initMap():void{
  //   var opts = {
  //       map:{
  //         center: [50.866210, 4.636548],
  //         zoom: 12
  //       },
  //       // markerZoomAnimation: false,
  //       // zoomControl: false,
  //       zoomControl: {
  //         position: "TopBottom" ,
  //       },
  //       otmLayer: {
  //         url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  //         options: {
  //           attribution: 'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
  //           /*subdomains:"1234"*/
  //         },
  //       },
  //       elevationControl: {
  //         data: "Rit_001_boortmeerbeek.gpx",
  //         options: {
  //           position: "topright",
  //           autohide:false,
  //           theme: "steelblue-theme", //default: lime-theme
  //           useHeightIndicator: true, //if false a marker is drawn at map position
  //           collapsed: true, //collapsed mode, show chart on click or mouseover
  //           detachedView: false, //if false the chart is drawn within map container
  //           elevationDiv: "#elevation-div", // if (detached), the elevation chart container
  //       },
  //     }
  //   }
    
  //   var map = new L.Map('map', {
  //     center: [50.866210, 4.636548],
  //     zoom: 12,
  //     zoomControl:false
  //   });

  //   var controlZoom = new L.Control.Zoom({
  //     position: "bottomleft"
  //   });
  //   controlZoom.addTo(map);
    
  //   const tiles = L.tileLayer(
  //     'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  //     {
  //       maxZoom: 18,
  //       minZoom: 3,
  //       attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
  //     }
  //   );

  //   tiles.addTo(map);
    
  //   var gpx = "assets/downloads/Rit_001_boortmeerbeek.gpx"; // URL to your GPX file or the GPX itself

  //   new L.GPX(
  //     gpx, {
  //       async: true,
  //       marker_options: {
  //         startIconUrl: '/assets/images/leaflet/images/pin-icon-start.png',
  //         endIconUrl: '/assets/images/leaflet/images/pin-icon-end.png',
  //         shadowUrl: '/assets/images/leaflet/images/pin-shadow.png'
  //       },
  //       polyline_options: {
  //         color: 'purple',
  //         opacity: 0.75,
  //         weight: 5,
  //         lineCap: 'square'
  //       }
  //     }).on('loaded', function(e:any) {
  //     map.fitBounds(e.target.getBounds());
  //   }).addTo(map);

  //   // this.controlElevation = (L.control as any).elevation({
  //   //   position: "topright",
  //   //   autohide:false,
  //   //   theme: "steelblue-theme", //default: lime-theme
  //   //   useHeightIndicator: true, //if false a marker is drawn at map position
  //   //   collapsed: true, //collapsed mode, show chart on click or mouseover
  //   //   detachedView: false, //if false the chart is drawn within map container
  //   //   elevationDiv: "#elevation-div", // if (detached), the elevation chart container
  //   // });
  //   // this.controlElevation.addTo(map);
  //   // this.controlElevation.loadData(gpx);
  //   // var baseLayers = {};
  //   // baseLayers.OTM = new L.TileLayer(opts.otmLayer.url, opts.otmLayer.options);
  
    
    
  //   // this.controlElevation = L.control.elevation(opts.elevationControl.options);
  // //   this.controlElevation = (L.control as any).elevation({   
  // //     position: "topright",
  // //     autohide:false,
  // //     theme: "steelblue-theme", //default: lime-theme
  // //     useHeightIndicator: true, //if false a marker is drawn at map position
  // //     collapsed: true, //collapsed mode, show chart on click or mouseover
  // //     detachedView: false, //if false the chart is drawn within map container
  // //     elevationDiv: "#elevation-div", // if (detached), the elevation chart container
  // // });
    
  

  // //   this.controlElevation.options.gpxOptions.marker_options.startIconUrl = 'images/pin-icon-start.png';
  // //   this.controlElevation.options.gpxOptions.marker_options.endIconUrl =  'images/pin-icon-end.png';
  // //   this.controlElevation.options.gpxOptions.marker_options.shadowUrl = 'images/marker-shadow.png';
  // //   this.controlElevation.options.gpxOptions.marker_options.wptIconUrls = {'': 'images/generic.png',};


  //   // controlZoom.addTo(map);
  //   // this.controlElevation.addTo(map); // attach elevation chart to map
  // //   this.controlElevation.loadData(opts.elevationControl.data); // url or plain gpx/geojson data
    
  // // //   console.log(controlElevation);
    
    
    
  // //   map.addLayer(baseLayers.OTM);
  
  // }
 
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/preview-track/preview-track.component.ts